import { motion } from "framer-motion";
import { useLang } from "@/lib/LanguageContext";

const fade = {
    hidden: { opacity: 0, y: 24 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.8, delay: i * 0.1, ease: [0.19, 1, 0.22, 1] },
    }),
};

export default function Benefits() {
    const { t } = useLang();
    const items = t("benefits.items") || [];
    return (
        <section
            id="benefits"
            className="py-24 md:py-40 bg-[#F9F6F0]"
            data-testid="benefits-section"
        >
            <div className="container-x">
                <motion.div
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-80px" }}
                    variants={fade}
                    className="mb-16 md:mb-24 max-w-4xl"
                >
                    <div className="chapter-num mb-4">{t("benefits.chapter")}</div>
                    <h2 className="font-serif text-5xl md:text-7xl text-[#2D2824] tracking-[-0.02em] leading-[0.98]">
                        {t("benefits.title_pre")}
                        <em className="italic text-[#B48F57]">
                            {t("benefits.title_em")}
                        </em>
                        {t("benefits.title_post")}
                    </h2>
                    <p className="mt-8 text-[15px] md:text-[17px] text-[#5C564D] leading-relaxed max-w-[52ch] font-light">
                        {t("benefits.body")}
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-0 border-t border-[#D9D1C7]">
                    {items.map((b, i) => (
                        <motion.div
                            key={b.n}
                            custom={i}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, margin: "-80px" }}
                            variants={fade}
                            className={`py-12 md:py-16 pr-6 md:pr-16 border-b border-[#D9D1C7] ${
                                i % 2 === 0
                                    ? "md:border-r md:pl-0"
                                    : "md:pl-16"
                            } group`}
                            data-testid={`benefit-${b.n}`}
                        >
                            <div className="flex items-baseline gap-6">
                                <span className="font-serif italic text-[#B48F57] text-2xl md:text-3xl w-10 shrink-0">
                                    {b.n}
                                </span>
                                <div>
                                    <h3 className="font-serif text-3xl md:text-4xl lg:text-5xl text-[#2D2824] tracking-[-0.01em] leading-tight mb-4">
                                        {b.title}
                                    </h3>
                                    <p className="text-[15px] md:text-[16px] text-[#5C564D] leading-relaxed max-w-[46ch] font-light">
                                        {b.body}
                                    </p>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
